import getters from './getters';
import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';

const state = {
  requests: [],
  requestListOptions: {
    sort: {
      id: 'asc',
    },
    // While we don’t implement lazy loading we have 25 records limit on BE by default.
    // For quick fix we should remove this limit.
    limit: 0,
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
